import { api, getLicenseId } from "../DefaultService";
import {
    ILocationCameraProps,
    ILocationProps
} from "./types";

const ENDPOINT = "v1/locations";

const handleApiError = (error: any): Error => {
    return new Error(error?.response?.data?.message || error?.response?.data?.error || "Erro interno do servidor!");
};

export const getMoovsecVehiclesAsync = async (
    active = true,
): Promise<ILocationProps[]> => {
    try {
        const licenseId = getLicenseId();
        const response = await api.get(`${ENDPOINT}/moovsec/vehicles?active=${active}`, {
            headers: licenseId ? { "X-License-Id": licenseId } : undefined,
        });
        return response.data;
    } catch (error) {
        throw handleApiError(error);
    }
};

export const getMoovsecVehicleRealtimeCamerasAsync = async (
    vehicleId: string,
    maxChannels = 4,
    channel?: number,
): Promise<ILocationCameraProps[]> => {
    try {
        const licenseId = getLicenseId();
        const channelParam = typeof channel === "number" ? `&channel=${channel}` : "";
        const response = await api.get(
            `${ENDPOINT}/moovsec/vehicles/${vehicleId}/cameras/realtime?maxChannels=${maxChannels}${channelParam}`,
            {
                headers: licenseId ? { "X-License-Id": licenseId } : undefined,
                timeout: 12000,
            },
        );

        return response.data;
    } catch (error) {
        throw handleApiError(error);
    }
};
